import Category from './Category'

const CategoryWrapper = () => {
  return <Category />
}

export default CategoryWrapper
